import * as React from 'react';
import { StoreProvider } from './src/context/store-context';
import { AuthProvider } from './src/context/auth-context';
import './src/scss/main.scss';

export const wrapRootElement = ({ element }) => {
	return (
		<AuthProvider>
			<StoreProvider>
				{element}
			</StoreProvider>
		</AuthProvider>
	);
};

//	Allows us to disable default behavior of scroll-to-top upon Gatsby's navigate() .
//	Usage:
//	navigate(pathname, {
//		state: {
//			disableScrollUpdate: true,
//		},
//	});
export const shouldUpdateScroll = ({ routerProps }) => {
	if (routerProps?.location?.state) {
		const { disableScrollUpdate } = routerProps.location.state;
		return !disableScrollUpdate;
	}
	return true;
};
